import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Box,
  Select,
  Button,
  TextInput,
  Text,
  MaskedInput,
  ResponsiveContext,
  Anchor
} from 'grommet';
import { Checkmark, Storage, Money, User } from 'grommet-icons';

import { ErrorForm, HeaderHtml } from '../../../components';
import { InputPassword } from '../../../components/form';
import Header from '../components/header/header';

import urlsApp from '../../../config/url-routes';

import { changeField, postCreateTrial } from '../actions/onboarding-actions';

import selectStateOptions from '../../../constants/select-state-options';
import selectRepresentingOptions from '../constants/select-representing-options';


const OnBoardingStart = (props) => {
  const callbackPostSuccess = () => {
    const { history } = props;
    history.push(urlsApp.onboardingWelcomeUrl);
  };

  const handlePost = formParams => {
    const {
      postCreateTrial
    } = props;

    postCreateTrial({ formParams, callbackSuccess: callbackPostSuccess });
  };

  const buildRepresentingNamePlaceholder = () => {
    const {
      representing,
    } = props;

    const option = selectRepresentingOptions.find(({ id }) => id === representing);

    return `Qual o nome do(a) ${option?.product?.toLowerCase()}?`;
  };


  const {
    name,
    telephone,
    city,
    state,
    representing,
    representingName,
    mail,
    password,
    postDataError,
    loadingPostForm,
    changeField,
  } = props;

  return (
    <ResponsiveContext.Consumer>
      {size => (
        <>
          <HeaderHtml title='Experimente grátis a solução perfeita para gerenciar seu mandato e campanha política' />
          <Header />

          <Box
            direction='column'
            align='center'
            pad={{
              horizontal: size === 'xsmall' || size === 'small' ? 'small' : 'medium'
            }}
          >
            {/* Cabeçalho */}
            <Box
              width='xlarge'
              pad={ size === 'small' ? 'large' : 'small' }
            >
              <Text
                size='xlarge'
                color='dark-1'
                weight='bolder'
              >
                Crie uma conta
              </Text>

              <Text
                size='small'
                color='dark-1'
                margin={{ top: 'none', bottom: 'none' }}
              >
                Experimente grátis por 15 dias!
              </Text>
            </Box>


            <Box
              direction={ size === 'small' ? 'column' : 'row' }
              width='xlarge'
              gap={
                size === 'xsmall' || size === 'small' ? 'small' : size
              }
            >
              {/* Primeira coluna */}
              <Box
                width='medium'
                fill='horizontal'
                gap={
                  size === 'small' ? 'medium' : 'small'
                }
                pad={
                  size === 'small' ? 'large' : 'small'
                }
              >
                {/* Nome */}
                <Box>
                  <Box gap='xsmall'>
                    <Text size='small' color='dark-2'>Nome *</Text>

                    <TextInput
                      placeholder='Como gostaria de ser chamado?'
                      value={name}
                      onChange={ event => changeField({ fieldName: 'name', value: event.target.value }) }
                    />
                  </Box>

                  <ErrorForm errorsList={postDataError.errors} fieldName='name' />
                </Box>


                {/* Telefone */}
                <Box>
                  <Box gap='xsmall'>
                    <Text size='small' color='dark-2'>Telefone *</Text>

                    <MaskedInput
                      mask={[
                        { fixed: '(' },
                        { length: 2, regexp: /\d/ },
                        { fixed: ')' },
                        { fixed: ' ' },
                        { length: 4, regexp: /\d/ },
                        { fixed: '-' },
                        { length: [4, 5], regexp: /\d/ }
                      ]}
                      placeholder='Número com DDD'
                      value={telephone}
                      onChange={ event => changeField({ fieldName: 'telephone', value: event.target.value }) }
                    />
                    </Box>

                  <ErrorForm errorsList={postDataError.errors} fieldName='telephone' />
                </Box>


                {/* Cidade */}
                <Box
                  direction={ size === 'small' ? 'column' : 'row' }
                  gap='small'
                >
                  <Box>
                    <Box
                      gap='xsmall'
                      width={ size === 'small' ? '100vw' : '50vw' }
                    >
                      <Text size='small' color='dark-2'>Cidade *</Text>

                      <TextInput
                        placeholder='Qual a sua cidade?'
                        value={city}
                        onChange={ event => changeField({ fieldName: 'city', value: event.target.value }) }
                      />
                    </Box>

                    <ErrorForm errorsList={postDataError.errors} fieldName='city' />
                  </Box>


                  {/* Estado */}
                  <Box>
                    <Box
                      gap='xsmall'
                      width={ size === 'small' ? '100vw' : '40vw' }
                    >
                      <Text size='small' color='dark-2'>Estado *</Text>

                      <Select
                        options={selectStateOptions}
                        value={state ?? ''}
                        placeholder='Qual seu estado?'
                        labelKey='name'
                        valueKey={{ key: 'id', reduce: true }}
                        onChange={({ value: nextValue }) => changeField({ fieldName: 'state', value: nextValue }) }
                        emptySearchMessage='Selecione uma opção'
                      />
                    </Box>

                    <ErrorForm errorsList={postDataError.errors} fieldName='state' />
                  </Box>
                </Box>


                {/* Represento */}
                <Box>
                  <Box gap='xsmall'>
                    <Text size='small' color='dark-2'>Represento (Sou) *</Text>

                    <Select
                      options={selectRepresentingOptions.filter(({ active }) => active)}
                      value={representing}
                      placeholder='Selecione uma opção'
                      labelKey='name'
                      valueKey={{ key: 'id', reduce: true }}
                      onChange={({ value: nextValue }) => changeField({ fieldName: 'representing', value: nextValue }) }
                      emptySearchMessage='Selecione uma opção'
                    />
                  </Box>

                  <ErrorForm errorsList={postDataError.errors} fieldName='representing' />
                </Box>


                {/* Represento Nome */}
                {representing && (
                  <Box>
                    <Box gap='xsmall'>
                      <Text size='small' color='dark-2'>Nome da autoridade que represento *</Text>

                      <TextInput
                        placeholder={buildRepresentingNamePlaceholder()}
                        value={representingName}
                        onChange={ event => changeField({ fieldName: 'representingName', value: event.target.value }) }
                      />
                    </Box>

                    <ErrorForm errorsList={postDataError.errors} fieldName='representingName' />
                  </Box>
                )}
              </Box>

              {/* Segunda coluna */}
              <Box
                width='medium'
                fill='horizontal'
                pad={ size === 'small' ? 'large' : 'small' }
                margin={{ left: size === 'small' ? 'none' : 'medium' }}
              >
                <Box
                  gap='xsmall'
                  margin={{
                    bottom: 'medium',
                  }}
                >
                  <Box
                    direction='row'
                    gap='small'
                    align='baseline'
                  >
                    <Money size='16px' color='dark-1' />

                    <Text size='small' color='dark-2'>
                      Sem cobrança durante o período de teste.
                    </Text>
                  </Box>

                  <Box
                    direction='row'
                    gap='small'
                    align='baseline'
                  >
                    <Checkmark size='16px' color='dark-1' />

                    <Text size='small' color='dark-2'>
                      Acesse todas as funcionalidades durante o período de teste.
                    </Text>
                  </Box>

                  <Box
                    direction='row'
                    gap='small'
                    align='baseline'
                  >
                    <User size='16px' color='dark-1' />

                    <Text size='small' color='dark-2'>
                      Sem limite de usuários.
                    </Text>
                  </Box>

                  <Box
                    direction='row'
                    gap='small'
                    align='baseline'
                  >
                    <Storage size='16px' color='dark-1' />

                    <Text size='small' color='dark-2'>
                      Banco de dados ilimitado.
                    </Text>
                  </Box>
                </Box>

                <Box
                  fill='horizontal'
                  border={{ color: 'light-6', side: 'bottom', size: 'xsmall' }}
                  margin={{
                    top: size === 'small' ? 'medium' : 'small',
                    bottom:  size === 'small' ? 'large' : 'medium',
                  }}
                />

                <Box
                  gap={ size === 'small' ? 'medium' : 'small' }
                  margin={{
                    bottom: 'medium',
                  }}
                >
                  {/* E-mail */}
                  <Box>
                    <Box gap='xsmall'>
                      <Text size='small' color='dark-2'>E-mail *</Text>

                      <TextInput
                        placeholder='Qual e-mail para acessar o sistema'
                        value={mail}
                        onChange={ event => changeField({ fieldName: 'mail', value: event.target.value }) }
                      />
                      </Box>

                    <ErrorForm errorsList={postDataError.errors} fieldName='mail' />
                  </Box>


                  {/* Senha */}
                  <Box>
                    <Box gap='xsmall'>
                      <Text size='small' color='dark-2'>Senha *</Text>

                      <InputPassword
                        value={password}
                        placeholder='Crie uma senha de pelo menos 8 digitos'
                        onChange={event =>
                          changeField({ fieldName: 'password', value: event.target.value })
                        }
                      />
                    </Box>

                    <ErrorForm errorsList={postDataError.errors} fieldName='password' />
                  </Box>
                </Box>


                <Box
                  margin={{
                    bottom: 'medium'
                  }}
                >
                  <Text
                    size='small'
                    color='dark-1'
                    //fill
                  >
                    Ao clicar em "Criar conta", você concorda com os <Anchor href={urlsApp.termsOfUse} target='_blank'>Termos de uso</Anchor> e com a <Anchor href={urlsApp.termsOfUse} target='_blank'>Política de Privacidade</Anchor>.
                  </Text>
                </Box>

                <Box>
                  <Button
                    primary
                    label={ !loadingPostForm ? 'Criar conta' : 'Carregando...' }
                    disabled={ loadingPostForm }
                    onClick={() => {
                      handlePost({
                        name,
                        telephone,
                        city,
                        state,
                        mail,
                        password,
                        representing,
                        representingName,
                      })
                    }}
                  />
                </Box>



              </Box>
            </Box>
          </Box>
        </>
      )}
    </ResponsiveContext.Consumer>
  )
}

const mapStateToProps = ({ onboardingReducer: { form } }) => ({
  name: form.name,
  telephone: form.telephone,
  city: form.city,
  state: form.state,
  representing: form.representing,
  representingName: form.representingName,
  mail: form.mail,
  password: form.password,
  postDataError: form.postDataError,
  loadingPostForm: form.loadingPostForm,
});

const mapdispatchToProps = dispatch => bindActionCreators({
  changeField,
  postCreateTrial,
}, dispatch);

export default withRouter(
  connect(mapStateToProps, mapdispatchToProps)(OnBoardingStart)
);
